module["exports"] = [
  "gem",
  "tem",
  "vijve",
  "zele"
]



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/nl_BE/address/city_suffix.js
// module id = 3318
// module chunks = 1610